export default "__VITE_ASSET__CN_dI13r__"